import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import ProjectLocationService from "../services/ProjectLocationService";
import ProjectService from "../services/ProjectService";
import StorageService from "../services/StorageService";
import Breadcrumb from "../components/Breadcrumb";
import LocationService from "../services/LocationService";
import ProjectStoreService from "../services/ProjectStoreService";
import ScreenData from "../config/ScreenData";
import ReactPaginate from "react-paginate";
import usePermission from "../utils/UsePermission";
import MessageDialog from "../components/MessageDialog";


export default function AddProjectLocation() {
  const [projects, setProjects] = useState([]);
  const [locations, setLocations] = useState([]);



  const [filteredLocations, setFilteredLocations] = useState([]);
  const [assignedLocations, setAssignedLocations] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedProjectChainage, setSelectedProjectChainage] = useState({
    fromKMS: "",
    toKMS: "",
    totalChainage: "",
  });
  const [loadingTable, setLoadingTable] = useState(false);

  const [stores, setStores] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState("");

  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [oldId, setOldId] = useState(null);
  const [dropdownsLoaded, setDropdownsLoaded] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [locationSearch, setLocationSearch] = useState("");

  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error");
  // const messageTimer = useRef(null);

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      projectId: "",
      locationId: "",
      status: "Active",
    },
  });

  const {
    register: modalRegister,
    getValues: modalValues,
    reset: resetModal,
  } = useForm();

  const fetchAssignedLocations = async (projectId, storeId) => {
    if (!permission || !checkView()) {
      setAssignedLocations([]);
      return;
    }
    setLoadingTable(true);

    try {
      const res = await ProjectLocationService.getByProjectId(projectId, currentPage, itemsPerPage);

      // ✅ CORRECT: array is res.data
      const list = Array.isArray(res.data) ? res.data : [];

      const filtered = list.filter(
        (loc) => String(loc.storeId) === String(storeId)
      );

      setAssignedLocations(filtered);
      setPageCount(res?.pagination?.totalPages || 1);
    } catch (error) {
      console.error("Failed to fetch project locations:", error);
      setAssignedLocations([]);
    } finally {
      setLoadingTable(false);
    }
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  const { permission, checkView, can } = usePermission(
    ScreenData.Project_Locations,
    showMessage
  );



  // useEffect(() => {
  //   if (locations.length > 0) {
  //     loadActiveLocations();
  //   }

  // }, [locations, assignedLocations, selectedStoreId]);

  useEffect(() => {
    if (locations.length > 0 && selectedProjectId) {
      loadActiveLocations();
    }
  }, [
    locations,
    assignedLocations,
    selectedStoreId,
    selectedProjectId,
    projects
  ]);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const companyId = StorageService.activeCompany().companyId;
        const projRes = await ProjectService.getActive(companyId);
        const locRes = await LocationService.getActive();

        setProjects(projRes.data || projRes || []);
        setLocations(locRes.data || locRes || []);

        setDropdownsLoaded(true);
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdowns();
  }, []);

  // const loadActiveLocations = () => {
  //   let active = locations.filter((l) => l.status === "Active");

  //   if (editMode && oldId) {
  //     const editData = JSON.parse(localStorage.getItem("editProjectLocation"));
  //     const current = locations.find((l) => l.id == editData.locationId);

  //     if (current && !active.some((l) => l.id === current.id)) {
  //       active = [...active, current];
  //     }
  //   }

  //   // Filter out already assigned locations for the selected store
  //   if (selectedStoreId && assignedLocations.length > 0) {
  //     const assignedLocationIds = assignedLocations.map((al) => al.locationId);
  //     active = active.filter((l) => !assignedLocationIds.includes(l.id));
  //   }

  //   setFilteredLocations(active);
  // };

  const loadActiveLocations = () => {

    // Selected project
    const selectedProject = projects.find(
      (p) => String(p.id) === String(selectedProjectId)
    );

    const projectFrom = Number(selectedProject?.fromKMS || 0);
    const projectTo = Number(selectedProject?.toKMS || 0);

    // Show only locations inside project chainage
    let active = locations.filter((l) => {

      if (l.status !== "Active") return false;

      const locFrom = Number(l.fromKMS);
      const locTo = Number(l.toKMS);

      return (
        locFrom >= projectFrom &&
        locTo <= projectTo
      );

    });

    // Keep current location while editing
    if (editMode && oldId) {

      const editData = JSON.parse(
        localStorage.getItem("editProjectLocation")
      );

      const current = locations.find(
        (l) => l.id == editData.locationId
      );

      if (current && !active.some((l) => l.id === current.id)) {
        active.push(current);
      }
    }

    // Remove already assigned locations
    if (selectedStoreId && assignedLocations.length > 0) {

      const assignedLocationIds = assignedLocations.map(
        (al) => al.locationId
      );

      active = active.filter(
        (l) => !assignedLocationIds.includes(l.id)
      );
    }

    setFilteredLocations(active);
  };

  useEffect(() => {
    if (!dropdownsLoaded) return;

    const editData = localStorage.getItem("editProjectLocation");
    if (editData) {
      const loc = JSON.parse(editData);
      setOldId(loc.id);
      setEditMode(true);

      setSelectedProjectId(loc.projectId);

      loadActiveLocations();
      fetchAssignedLocations(loc.projectId, loc.storeId);

      reset({
        projectId: loc.projectId || "",
        locationId: loc.locationId || "",
        status: loc.status || "Active",
      });
    }
  }, [dropdownsLoaded, reset]);

  useEffect(() => {
    setCurrentPage(1);
  }, [assignedLocations, selectedProjectId]);

  useEffect(() => {
    if (permission && checkView()) {
      if (selectedProjectId && selectedStoreId) {
        fetchAssignedLocations(selectedProjectId, selectedStoreId);
      }
    }
  }, [currentPage, selectedProjectId, selectedStoreId, permission]);



  useEffect(() => {
    if (permission) {
      checkView();
    }
  }, [permission]);

  useEffect(() => {
    if (selectedProjectId && projects.length > 0) {
      const selectedProj = projects.find((p) => String(p.id) === String(selectedProjectId));
      if (selectedProj) {
        setSelectedProjectChainage({
          fromKMS: selectedProj.fromKMS !== null && selectedProj.fromKMS !== undefined ? parseFloat(selectedProj.fromKMS).toFixed(3) : "0.000",
          toKMS: selectedProj.toKMS !== null && selectedProj.toKMS !== undefined ? parseFloat(selectedProj.toKMS).toFixed(3) : "0.000",
          totalChainage: selectedProj.totalChainage !== null && selectedProj.totalChainage !== undefined ? parseFloat(selectedProj.totalChainage).toFixed(3) : "0.000",
        });
      } else {
        setSelectedProjectChainage({ fromKMS: "", toKMS: "", totalChainage: "" });
      }
    } else {
      setSelectedProjectChainage({ fromKMS: "", toKMS: "", totalChainage: "" });
    }
  }, [selectedProjectId, projects]);

  // const closeMessage = () => setMessage("");

  const onSubmit = async (data) => {
    if (editMode && !can("canModify")) {
      showMessage("No permission", "error");
      return;
    }

    if (!editMode && !can("canAdd")) {
      showMessage("No permission", "error");
      return;
    }
    setLoading(true);

    const payload = {
      projectId: data.projectId,
      locationId: data.locationId,
      status: data.status,
      updatedBy: StorageService.loginData().employeeId,
      updatedDate: new Date().toISOString(),
      ...(editMode
        ? {}
        : {
          createdBy: StorageService.loginData().employeeId,
          createdDate: new Date().toISOString(),
        }),
    };

    try {
      let res;
      if (editMode) {
        res = await ProjectLocationService.update(oldId, payload);
      } else {
        res = await ProjectLocationService.create(payload);
      }

      if (res.status) {
        showMessage(
          editMode ? "Updated Successfully" : "Added Successfully",
          "success"
        );

        fetchAssignedLocations(payload.projectId);

        localStorage.removeItem("editProjectLocation");
        setTimeout(() => navigate("/cpnl/projectlocation/view"), 1000);
      } else {
        showMessage(res.message || "Failed to save", "error");
      }
    } catch (err) {
      showMessage(err.response?.data?.message || "Error saving data", "error");
    } finally {
      setLoading(false);
    }
  };


  const displayedUnassignedLocations = filteredLocations.filter((l) => {
    if (!locationSearch) return true;
    const search = locationSearch.toLowerCase();
    return (
      l.locationName?.toLowerCase().includes(search) ||
      `${l.fromKMS}`.includes(search) ||
      `${l.toKMS}`.includes(search)
    );
  });

  const isAllLocationsSelected =
    displayedUnassignedLocations.length > 0 &&
    displayedUnassignedLocations.every((loc) =>
      selectedLocations.some((s) => s.locationId === loc.id)
    );

  const handleToggleSelectAllLocations = () => {
    if (isAllLocationsSelected) {
      const displayedIds = new Set(displayedUnassignedLocations.map((l) => l.id));
      setSelectedLocations((prev) => prev.filter((s) => !displayedIds.has(s.locationId)));
    } else {
      setSelectedLocations((prev) => {
        const existingMap = new Map(prev.map((s) => [s.locationId, s]));
        displayedUnassignedLocations.forEach((loc) => {
          if (!existingMap.has(loc.id)) {
            existingMap.set(loc.id, {
              locationId: loc.id,
              locationName: loc.locationName,
              fromKMS: loc.fromKMS,
              toKMS: loc.toKMS,
            });
          }
        });
        return Array.from(existingMap.values());
      });
    }
  };

  const handleToggleSingleLocation = (loc) => {
    setSelectedLocations((prev) => {
      const exists = prev.some((s) => s.locationId === loc.id);
      if (exists) {
        return prev.filter((s) => s.locationId !== loc.id);
      } else {
        return [
          ...prev,
          {
            locationId: loc.id,
            locationName: loc.locationName,
            fromKMS: loc.fromKMS,
            toKMS: loc.toKMS,
          },
        ];
      }
    });
  };

  const handleAddLocationClick = () => {

    // clear old messages
    setMessage("");
    if (!can("canAdd")) {
      showMessage("No Add Permission", "error");
      return;
    }

    if (!selectedProjectId || !selectedStoreId) {
      showMessage("Select project and store to add", "danger");
      return;
    }

    // reset modal form
    resetModal();
    setLocationSearch("");
    loadActiveLocations();
    setShowModal(true);
    setSelectedLocations([]);
  };

  const handleAddLocation = async () => {
    if (!can("canAdd")) {
      showMessage("No Permission", "error");
      return;
    }

    if (selectedLocations.length === 0) {
      showMessage("Please select at least one location", "error");
      return;
    }

    try {
      for (const loc of selectedLocations) {
        const payload = {
          companyId: StorageService.activeCompany().companyId,
          projectId: selectedProjectId,
          storeId: selectedStoreId,
          locationId: loc.locationId,
          status: "Active",
          createdBy: StorageService.loginData().employeeId,
          updatedBy: StorageService.loginData().employeeId,
        };

        await ProjectLocationService.create(payload);
      }

      showMessage("Locations assigned successfully!", "success");

      setSelectedLocations([]);
      setShowModal(false);

      fetchAssignedLocations(selectedProjectId, selectedStoreId);
    } catch (err) {
      showMessage(
        err.response?.data?.message || "Failed to assign locations",
        "error"
      );
    }
  };

  // const handleAddLocation = async () => {
  //   const data = modalValues();

  //   if (!can("canAdd")) {
  //     showMessage("No Permission", "error");
  //     return;
  //   }

  //   if (!data.locationId) {
  //     showMessage("Please select a location", "error");
  //     return;
  //   }

  //   const payload = {
  //     companyId: StorageService.activeCompany().companyId,
  //     projectId: selectedProjectId,
  //     storeId: selectedStoreId,   // ✅ REQUIRED
  //     locationId: data.locationId,
  //     status: "Active",
  //     createdBy: StorageService.loginData().employeeId,
  //     updatedBy: StorageService.loginData().employeeId,
  //   };

  //   try {
  //     await ProjectLocationService.create(payload);

  //     showMessage("Location assigned successfully!", "success");

  //     resetModal();
  //     setShowModal(false);

  //     fetchAssignedLocations(selectedProjectId);
  //   } catch (err) {
  //     showMessage(
  //       err.response?.data?.message || "Failed to assign location",
  //       "error"
  //     );
  //   }
  // };

  const handleCancel = () => {
    localStorage.removeItem("editProjectLocation");
    navigate("/cpnl/projectlocation/view");
  };

  const handleStatusToggle = async (id, currentStatus) => {

    if (!can("canModify")) {
      showMessage("No Modify Permission", "error");
      return;
    }

    const action =
      currentStatus === "Active"
        ? "Inactive"
        : "Active";

    const confirmed = window.confirm(
      `Are you sure you want to change the status to ${action}?`
    );

    if (!confirmed) return;

    try {

      await ProjectLocationService.updateStatus(id);

      await fetchAssignedLocations(
        selectedProjectId,
        selectedStoreId
      );

      showMessage(
        `Status changed to ${action} successfully`,
        "success"
      );

    } catch (err) {

      showMessage(
        err?.response?.data?.message ||
        "Failed to update status",
        "error"
      );
    }
  };


  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Project Location" : "Project Locations"}
        secondTitle="Projects"
      />

      <MessageDialog
        message={message}
        type={msgType}
        setMessage={setMessage}
        setMsgType={setMsgType}
      />


      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {/* MESSAGES */}
          {/* {message && (
            <div
              className={`alert ${msgType === "success"
                ? "alert-success"
                : msgType === "info"
                  ? "alert-info"
                  : "alert-danger"
                } d-flex justify-content-between align-items-center mb-3 p-2`}
            >
              <span>{message}</span>
              <button className="btn-close" onClick={closeMessage}></button>
            </div>
          )} */}

          {/* FORM */}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row mb-3">
              {/* PROJECT */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Project <span className="text-danger">*</span></label>
                <select
                  className={`form-select ${errors.projectId ? "is-invalid" : ""
                    }`}
                  {...register("projectId", {
                    required: "Project is required",
                  })}
                  onChange={async (e) => {
                    const pid = e.target.value;

                    setValue("projectId", pid);
                    setSelectedProjectId(pid);

                    setSelectedStoreId("");     // reset store
                    setStores([]);              // reset stores
                    setAssignedLocations([]);   // reset table

                    if (!pid) return;

                    // ✅ LOAD STORES ASSIGNED TO PROJECT
                    const res = await ProjectStoreService.getProjectStoreById(pid);
                    setStores(res.data || res || []);
                  }}
                >
                  <option value="">Select Project</option>
                  {projects.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.projectName}-{p.projectCode}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Store <span className="text-danger">*</span></label>

                <select
                  className="form-select"
                  value={selectedStoreId}
                  disabled={!selectedProjectId}
                  onChange={(e) => {
                    const sid = e.target.value;
                    setSelectedStoreId(sid);

                    if (sid) {
                      fetchAssignedLocations(selectedProjectId, sid);
                    } else {
                      setAssignedLocations([]);
                    }
                  }}
                >
                  <option value="">Select Store</option>

                  {stores.map((s) => (
                    <option key={s.storeId} value={s.storeId}>
                      {s.storeName} ({s.storeCode})
                    </option>
                  ))}
                </select>
              </div>

              {/* Start Chainage */}
              <div className="col-md-4 mb-3">
                <label className="form-label">Start Chainage</label>
                <input
                  type="text"
                  className="form-control bg-light"
                  value={selectedProjectChainage.fromKMS}
                  readOnly
                  placeholder="0.000"
                  style={{ fontWeight: "bold", color: "#212529" }}
                />
              </div>

              {/* End Chainage */}
              <div className="col-md-4 mb-3">
                <label className="form-label">End Chainage</label>
                <input
                  type="text"
                  className="form-control bg-light"
                  value={selectedProjectChainage.toKMS}
                  readOnly
                  placeholder="0.000"
                  style={{ fontWeight: "bold", color: "#212529" }}
                />
              </div>

              {/* Total Chainage */}
              <div className="col-md-4 mb-3">
                <label className="form-label">Total Chainage</label>
                <input
                  type="text"
                  className="form-control bg-light"
                  value={selectedProjectChainage.totalChainage}
                  readOnly
                  placeholder="0.000"
                  style={{ fontWeight: "bold", color: "#212529" }}
                />
              </div>

              {/* LOCATION */}
              {/* <div className="col-md-6 mb-3">
                <label className="form-label">Location *</label>
                <select
                  className={`form-select ${
                    errors.locationId ? "is-invalid" : ""
                  }`}
                  {...register("locationId", {
                    required: "Location is required",
                  })}
                >
                  <option value="">Select Location</option>
                  {filteredLocations.map((l) => (
                    <option key={l.id} value={l.id}>
                      {l.locationName} ({l.fromKMS} KMs To {l.toKMS} KMs)
                    </option>
                  ))}
                </select>
              </div> */}
            </div>

            {/* BUTTONS */}
            {/* <button
              className="btn btn-primary me-2"
              type="submit"
              disabled={loading}
            >
              {loading
                ? editMode
                  ? "Updating..."
                  : "Saving..."
                : editMode
                ? "Update"
                : "Save"}
            </button>

            <button
              className="btn btn-secondary"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button> */}
          </form>

          <div className="card mt-4">
            <div className="card-header d-flex justify-content-between">
              <h5>Assigned Locations</h5>

              {can("canAdd") && (
                <button
                  className="d-inline-flex btn btn-success me-2"
                  onClick={handleAddLocationClick}
                >
                  <i className="ti ti-plus me-1"></i> Add Location
                </button>
              )}
            </div>

            <div className="card-body">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Location Name</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {loadingTable ? (
                    <tr>
                      <td colSpan="2" className="text-center">
                        Loading...
                      </td>
                    </tr>
                  ) : assignedLocations.length > 0 ? (
                    assignedLocations.map((loc) => (
                      <tr key={loc.id}>
                        <td>
                          {loc.locationName} ({loc.fromKMS} KMs To {loc.toKMS}{" "}
                          KMs)
                        </td>

                        <td>
                          <span
                            className={`badge ${loc.status === "Active"
                              ? "bg-success"
                              : "bg-danger"
                              }`}
                            style={{
                              cursor: "pointer",
                              padding: "8px 12px"
                            }}
                            onClick={() =>
                              handleStatusToggle(
                                loc.id,
                                loc.status
                              )
                            }
                            title="Click to change status"
                          >
                            {loc.status}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="text-center text-muted">
                        No locations assigned to this project
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <ReactPaginate
                // forcePage={currentPage - 1}
                forcePage={Math.max(0, currentPage - 1)}
                breakLabel="..."
                nextLabel="Next >"
                previousLabel="< Previous"
                onPageChange={(e) => setCurrentPage(e.selected + 1)}
                pageCount={pageCount}   // ✅ IMPORTANT
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
              />
            </div>
          </div>

          {/* POPUP MODAL */}
          {showModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(15, 23, 42, 0.6)",
                backdropFilter: "blur(4px)",
                zIndex: 1050,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  maxWidth: "650px",
                  maxHeight: "90vh",
                  background: "#ffffff",
                  borderRadius: "12px",
                  boxShadow: "0 20px 25px -5px rgba(0,0,0,0.15), 0 10px 10px -5px rgba(0,0,0,0.04)",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  zIndex: 1060,
                }}
              >
                {/* Modal Header */}
                <div
                  className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom"
                  style={{ backgroundColor: "#f8fafc" }}
                >
                  <div>
                    <h5 className="mb-0 fw-bold text-dark">Assign Location</h5>
                    {selectedProjectId && (
                      <small className="text-muted">
                        Project: <span className="fw-semibold text-primary">
                          {projects.find((p) => String(p.id) === String(selectedProjectId))?.projectName || ""}
                        </span>
                        {selectedStoreId && (
                          <> | Store: <span className="fw-semibold text-primary">
                            {stores.find((s) => String(s.storeId || s.id) === String(selectedStoreId))?.storeName || ""}
                          </span></>
                        )}
                      </small>
                    )}
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setShowModal(false)}
                  />
                </div>

                {/* Modal Body */}
                <div className="p-4" style={{ overflowY: "auto" }}>
                  <div className="card border rounded p-3 bg-light">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div className="d-flex align-items-center gap-2">
                        <h6 className="fw-bold mb-0 text-dark">Unassigned Locations</h6>
                        <span className="badge bg-primary rounded-pill px-3 py-1">
                          {selectedLocations.length} Selected
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        style={{ maxWidth: "260px" }}
                        placeholder="🔍 Filter locations..."
                        value={locationSearch}
                        onChange={(e) => setLocationSearch(e.target.value)}
                      />
                    </div>

                    {filteredLocations.length === 0 ? (
                      <div className="text-center py-4 text-muted bg-white border rounded">
                        No unassigned locations available for this project & store.
                      </div>
                    ) : (
                      <div className="table-responsive bg-white border rounded" style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-hover table-striped mb-0 align-middle">
                          <thead className="table-light sticky-top" style={{ top: 0, zIndex: 1 }}>
                            <tr>
                              <th style={{ width: "130px" }}>
                                <div className="form-check mb-0">
                                  <input
                                    type="checkbox"
                                    className="form-check-input cursor-pointer"
                                    id="selectAllLocationsCheckbox"
                                    checked={isAllLocationsSelected}
                                    onChange={handleToggleSelectAllLocations}
                                  />
                                  <label className="form-check-label fw-bold cursor-pointer mb-0" htmlFor="selectAllLocationsCheckbox">
                                    Select All
                                  </label>
                                </div>
                              </th>
                              <th>Location Name</th>
                              <th style={{ width: "220px" }}>Chainage (KMs)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {displayedUnassignedLocations.length > 0 ? (
                              displayedUnassignedLocations.map((loc) => {
                                const isChecked = selectedLocations.some((s) => s.locationId === loc.id);
                                return (
                                  <tr key={loc.id} className={isChecked ? "table-active" : ""}>
                                    <td>
                                      <div className="form-check mb-0">
                                        <input
                                          type="checkbox"
                                          className="form-check-input cursor-pointer"
                                          checked={isChecked}
                                          onChange={() => handleToggleSingleLocation(loc)}
                                        />
                                      </div>
                                    </td>
                                    <td className="fw-semibold text-dark">{loc.locationName}</td>
                                    <td>{loc.fromKMS} KMs To {loc.toKMS} KMs</td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-center py-3 text-muted">
                                  No locations match your filter search.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>

                {/* Modal Footer */}
                <div className="px-4 py-3 bg-light border-top d-flex justify-content-between align-items-center">
                  <span className="text-muted small">
                    {selectedLocations.length > 0 ? `${selectedLocations.length} location(s) ready to assign` : "No location selected"}
                  </span>
                  <div className="d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-outline-secondary px-4"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>

                    {can("canAdd") && (
                      <button
                        type="button"
                        className="btn btn-primary px-4"
                        disabled={selectedLocations.length === 0}
                        onClick={handleAddLocation}
                      >
                        {selectedLocations.length > 0 ? `Assign (${selectedLocations.length}) Locations` : "Assign Locations"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
